var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknownDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unknown-device",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_79426",
    "data-name": "Path 79426",
    d: "M29.054,0H2.946A2.944,2.944,0,0,0,0,2.946V25.037a2.944,2.944,0,0,0,2.946,2.946H9.037v2.142H5.958a.938.938,0,0,0,0,1.875H26.042a.938.938,0,0,0,0-1.875H22.962V27.983h6.092A2.944,2.944,0,0,0,32,25.037V2.946A2.944,2.944,0,0,0,29.054,0ZM21.087,30.125H10.912V27.983H21.087Zm9.038-5.087a1.07,1.07,0,0,1-1.071,1.071H2.946a1.07,1.07,0,0,1-1.071-1.071V22.763a2.944,2.944,0,0,0,1.07.2h26.11a2.931,2.931,0,0,0,1.07-.2Zm0-5.021a1.07,1.07,0,0,1-1.071,1.071H2.946a1.07,1.07,0,0,1-1.071-1.071V2.946A1.07,1.07,0,0,1,2.946,1.875H29.054a1.07,1.07,0,0,1,1.071,1.071Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79427",
    "data-name": "Path 79427",
    d: "M241.938,281.167a.938.938,0,1,0,.938.938A.938.938,0,0,0,241.938,281.167Z",
    transform: "translate(-225.938 -263.594)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79428",
    "data-name": "Path 79428",
    d: "M181.687,64.267a4.959,4.959,0,0,0-4.953,4.953.938.938,0,1,0,1.875,0,3.079,3.079,0,1,1,3.079,3.08.938.938,0,0,0-.937.938v2.008a.938.938,0,0,0,1.875,0v-1.16A4.958,4.958,0,0,0,181.687,64.267Z",
    transform: "translate(-165.688 -60.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownDevice);
export default __webpack_public_path__ + "static/media/unknown-device.d1f448150a513adc06823fcc22124f7e.svg";
export { ForwardRef as ReactComponent };